// test645
(645 && 0);
